module.exports = __webpack_public_path__ + "img/gcp-svgrepo-com.b078744a.svg";